import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'help',
    lazy: async () => ({ Component: (await import('./HelpPage')).HelpPage }),
  },
];
